export default {
  data: [
    {
      id: 'btn_3month_fb',
      type: 'premium',
      months: 3,
      price: 1500,
      discount: 1500,
      perMonth: 500,
      pid: 8521
    },
    {
      id: 'btn_6month_fb',
      type: 'premium',
      months: 6,
      price: 3000,
      discount: 2799,
      perMonth: 466.5,
      pid: 8520
    },
    {
      id: 'btn_12month_fb',
      type: 'premium',
      months: 12,
      price: 6000,
      discount: 4999,
      perMonth: 416.58,
      pid: 8519
    },
    {
      id: 'btn_presets_fb',
      type: 'preset',
      months: 0,
      price: 300,
      discount: 300,
      perMonth: 0,
      pid: 31403
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/data/premiums.js